import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { ExercisepartModel } from './exercisepart.model';
import { OnlinetestModel } from './onlinetest.model';

export class SlotModel extends BaseModel implements Deserializable {

  // columns
  type: string;
  name: string;
  start_time: number; // tslint:disable-line: variable-name
  duration: number;
  for_candidate: boolean; // tslint:disable-line: variable-name
  for_observer: boolean; // tslint:disable-line: variable-name

  // relations
  exercisepart: ExercisepartModel;
  onlinetest: OnlinetestModel;

  deserialize(input: any): this {
    Object.assign(this, input);
    // exercisepart
    if (this.exercisepart !== null && this.exercisepart !== undefined) {
      this.exercisepart = new ExercisepartModel().deserialize(this.exercisepart);
    }
    // onlinetest
    if (this.onlinetest !== null && this.onlinetest !== undefined) {
      this.onlinetest = new OnlinetestModel().deserialize(this.onlinetest);
    }
    return this;
  }

  public get slot_name(): string {
    return (this.name !== null) ? this.name : ((this.exercisepart !== null) ? this.exercisepart.name : '');
  }

  public get icon(): string {
    switch (this.type) {
      case('org'): return 'pi pi-users';
      case('break'): return 'pi pi-moon';
      case('conference'): return 'pi pi-chart-line';
      case('exercisepart'): return 'pi pi-briefcase';
      case('onlinetest'): return 'pi pi-id-card';
    }
  }

  public get is_for_candidate(): boolean {
    return (this.for_candidate === true || this.exercisepart?.for_candidate === true);
  }

  public get is_for_observer(): boolean {
    return (this.for_observer === true || this.exercisepart?.for_observer === true);
  }

}
